var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-titles py-2"},[_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }